import * as actionTypes from "./actionTypes";

const initialState = {
  // Home Categories (for carousel)
  homeCategories: [],
  homeCategoriesLoading: false,
  homeCategoriesError: null,
  
  // All Categories
  allCategories: [],
  allCategoriesLoading: false,
  allCategoriesError: null,
  
  // Single Category
  currentCategory: null,
  currentCategoryLoading: false,
  currentCategoryError: null,
  
  // Search Categories
  searchResults: [],
  searchLoading: false,
  searchError: null,
  searchTerm: "",
  
  // General
  lastUpdated: null,
  
  // Categories with Products
  categoriesWithProducts: [],
  categoriesWithProductsLoading: false,
  categoriesWithProductsError: null,

  // Category Tree (L1 -> L2 -> L3, for the Categories browse page)
  categoryTree: [],
  categoryTreeLoading: false,
  categoryTreeError: null,

  // Category Items (products for a single L1/L2/L3 node)
  categoryItems: [],
  categoryItemsTotal: 0,
  categoryItemsPage: 1,
  categoryItemsPerPage: 20,
  categoryItemsLoading: false,
  categoryItemsError: null
};

export default function categoriesReducer(state = initialState, action) {
  switch (action.type) {
    // Home Categories
    case actionTypes.GET_HOME_CATEGORIES_REQUEST:
      return {
        ...state,
        homeCategoriesLoading: true,
        homeCategoriesError: null
      };
    
    case actionTypes.GET_HOME_CATEGORIES_SUCCESS:
      return {
        ...state,
        homeCategories: action.payload,
        homeCategoriesLoading: false,
        homeCategoriesError: null,
        lastUpdated: new Date().toISOString()
      };
    
    case actionTypes.GET_HOME_CATEGORIES_FAILURE:
      return {
        ...state,
        homeCategoriesLoading: false,
        homeCategoriesError: action.payload
      };
    
    // All Categories
    case actionTypes.GET_ALL_CATEGORIES_REQUEST:
      return {
        ...state,
        allCategoriesLoading: true,
        allCategoriesError: null
      };
    
    case actionTypes.GET_ALL_CATEGORIES_SUCCESS:
      return {
        ...state,
        allCategories: action.payload,
        allCategoriesLoading: false,
        allCategoriesError: null,
        lastUpdated: new Date().toISOString()
      };
    
    case actionTypes.GET_ALL_CATEGORIES_FAILURE:
      return {
        ...state,
        allCategoriesLoading: false,
        allCategoriesError: action.payload
      };
    
    // Single Category
    case actionTypes.GET_CATEGORY_BY_SLUG_REQUEST:
      return {
        ...state,
        currentCategoryLoading: true,
        currentCategoryError: null
      };
    
    case actionTypes.GET_CATEGORY_BY_SLUG_SUCCESS:
      return {
        ...state,
        currentCategory: action.payload,
        currentCategoryLoading: false,
        currentCategoryError: null
      };
    
    case actionTypes.GET_CATEGORY_BY_SLUG_FAILURE:
      return {
        ...state,
        currentCategoryLoading: false,
        currentCategoryError: action.payload
      };
    
    // Search Categories
    case actionTypes.SEARCH_CATEGORIES_REQUEST:
      return {
        ...state,
        searchLoading: true,
        searchError: null
      };
    
    case actionTypes.SEARCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        searchResults: action.payload,
        searchLoading: false,
        searchError: null
      };
    
    case actionTypes.SEARCH_CATEGORIES_FAILURE:
      return {
        ...state,
        searchLoading: false,
        searchError: action.payload
      };
    
    // Clear/Reset
    case actionTypes.CLEAR_CATEGORIES_ERROR:
      return {
        ...state,
        homeCategoriesError: null,
        allCategoriesError: null,
        currentCategoryError: null,
        searchError: null
      };
    
    case actionTypes.RESET_CATEGORIES_STATE:
      return initialState;
    
    // Categories with Products
    case actionTypes.GET_CATEGORIES_WITH_PRODUCTS_REQUEST:
      return {
        ...state,
        categoriesWithProductsLoading: true,
        categoriesWithProductsError: null
      };
    case actionTypes.GET_CATEGORIES_WITH_PRODUCTS_SUCCESS:
      return {
        ...state,
        categoriesWithProducts: action.payload,
        categoriesWithProductsLoading: false,
        categoriesWithProductsError: null
      };
    case actionTypes.GET_CATEGORIES_WITH_PRODUCTS_FAILURE:
      return {
        ...state,
        categoriesWithProducts: [],
        categoriesWithProductsLoading: false,
        categoriesWithProductsError: action.payload
      };

    // Category Tree
    case actionTypes.GET_CATEGORY_TREE_REQUEST:
      return {
        ...state,
        categoryTreeLoading: true,
        categoryTreeError: null
      };

    case actionTypes.GET_CATEGORY_TREE_SUCCESS:
      return {
        ...state,
        categoryTree: action.payload,
        categoryTreeLoading: false,
        categoryTreeError: null
      };

    case actionTypes.GET_CATEGORY_TREE_FAILURE:
      return {
        ...state,
        categoryTreeLoading: false,
        categoryTreeError: action.payload
      };

    // Category Items
    case actionTypes.GET_CATEGORY_ITEMS_REQUEST:
      return {
        ...state,
        categoryItemsLoading: true,
        categoryItemsError: null
      };

    case actionTypes.GET_CATEGORY_ITEMS_SUCCESS:
      return {
        ...state,
        categoryItems: action.payload.append
          ? [...state.categoryItems, ...action.payload.items]
          : action.payload.items,
        categoryItemsTotal: action.payload.total,
        categoryItemsPage: action.payload.page,
        categoryItemsPerPage: action.payload.perPage,
        categoryItemsLoading: false,
        categoryItemsError: null
      };

    case actionTypes.GET_CATEGORY_ITEMS_FAILURE:
      return {
        ...state,
        categoryItemsLoading: false,
        categoryItemsError: action.payload
      };

    case actionTypes.RESET_CATEGORY_ITEMS:
      return {
        ...state,
        categoryItems: [],
        categoryItemsTotal: 0,
        categoryItemsPage: 1,
        categoryItemsError: null
      };

    default:
      return state;
  }
} 